import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Bar,
  mixins: [reactiveProp],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              //stacked: true,
              ticks: {
                stepSize: 1
              }
            }
          ],
          yAxes: [
            {
              //stacked: true,
              ticks: {
                stepSize: 1,
                beginAtZero: true
              }
            }
          ]
        },
        layout: {
          padding: {
            right: 0,
            left: 0,
            top: 0,
            bottom: 0 //35 partout avant set that fits the best
          }
        },
        legend: {
          display: true,
          position: "bottom",
          align: "end"
        }
      }
    };
  }
};
